export default __webpack_public_path__ + "static/media/study_log.68acb3f7.svg";